import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import twoStageBasketLift from '../assets/img/2 Stage with Basket Lifting/img44.jpg'
import twoStageFiltration from '../assets/img/2 Stage with Filtration/img49.jpg'
import AboutImage from "../assets/img/multiStageFour.jpg"
import VideoSection from "../components/videoSection";
const Home = () => {
  return (
    <div className="home">
      {/* Hero Section - Keeping original text colors */}
      <section className="bg-gray-900 heroBg text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20 bg-cover bg-center" />
        <div className="relative mx-auto max-w-screen-xl px-4 py-32 lg:flex lg:h-screen lg:items-center">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-3xl font-extrabold text-transparent sm:text-5xl">
              Ultronics&nbsp;
              <span className="sm:block">
              Precision Cleaning Solutions for Industrial Excellence
              </span>
            </h1>

            <p className="mx-auto mt-4 max-w-xl sm:text-xl/relaxed">
              Manufacturer of Special Purpose Machines for Industrial
              Cleaning / Ultrasonic Cleaning Applications
            </p>

            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link
                to="/products"
                className="group relative inline-flex items-center overflow-hidden rounded-lg border border-blue-600 bg-blue-600 px-12 py-3 text-sm font-medium text-white transition hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-opacity-75 sm:w-auto"
              >
                <span className="absolute -end-full transition-all group-hover:end-4">
                  <ChevronRight className="h-5 w-5" />
                </span>
                <span className="transition-all group-hover:me-4">
                  Our Products
                </span>
              </Link>

              <Link
                to="/contact"
                className="group relative inline-flex items-center overflow-hidden rounded-lg border border-blue-600 px-12 py-3 text-sm font-medium text-white transition hover:bg-blue-600 focus:outline-none focus:ring active:bg-blue-500 sm:w-auto"
              >
                <span className="absolute -end-full transition-all group-hover:end-4">
                  <ChevronRight className="h-5 w-5" />
                </span>
                <span className="transition-all group-hover:me-4">
                  Enquire
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="bg-white text-black">
        <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
            <div className="relative h-64 overflow-hidden rounded-2xl shadow-lg transition-transform hover:scale-105 duration-300 sm:h-80 lg:order-last lg:h-full">
              <img
                alt=""
                src={AboutImage}
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>

            <div className="lg:py-24">
              <h2 className="text-3xl bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-transparent font-bold sm:text-4xl">
                About Us
              </h2>

              <p className="mt-4 text-gray-600">
                At Ultronics, we specialize in the design and manufacture of special purpose machines for industrial and ultrasonic cleaning applications. With a focus on innovation and quality, we cater to a wide range of industries, including automotive, aerospace, healthcare, electronics, and more. Our solutions ensure precision cleaning for even the most complex components, delivering efficiency and sustainability.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section>
        <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
          <header className="text-center mb-8">
            <h2 className="text-xl font-bold text-gray-900 sm:text-3xl bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-transparent">
              Our Range Of Products
            </h2>
          </header>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mx-auto sm:w-3/4">
            <Link to="/products?category=Industrial Ultrasonic Cleaning Machine" 
                  className="group relative block rounded-2xl border border-gray-100 shadow-lg transition-all duration-300 hover:shadow-xl w-3/4 place-self-center overflow-hidden">
              <img
                src={twoStageBasketLift}
                alt=""
                className="h-80 w-full rounded-2xl border border-gray-300 object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="p-4 text-center">
                <strong className="text-xl font-medium text-gray-900">
                  Ultrasonic Machines
                </strong>
                <span className="mt-4 block rounded-md border border-indigo-900 bg-indigo-900 px-5 py-3 text-sm font-medium uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-indigo-900">
                  Learn More
                </span>
              </div>
            </Link>

            <Link to="/products?category=special purpose"
                  className="group relative block rounded-2xl border border-gray-100 shadow-lg transition-all duration-300 hover:shadow-xl w-3/4 place-self-center overflow-hidden">
              <img
                src={twoStageFiltration}
                alt=""
                className="h-80 w-full rounded-2xl border border-gray-300 object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="py-4 text-center">
                <strong className="text-xl font-medium text-gray-900">
                  Special Purpose Machines
                </strong>
                <span className="mt-4 block rounded-md border border-indigo-900 bg-indigo-900 px-5 py-3 text-sm font-medium uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-indigo-900">
                  Learn More
                </span>
              </div>
            </Link>
          </div>
        </div>
      </section>
      {/* Video Section */}
      <section className="bg-white text-black">
        <VideoSection/>
      </section>
      {/* Features Section */}
      <section className="bg-white text-black">
        <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
          <div className="mx-auto pb-4 text-center">
            <h2 className="text-3xl font-bold sm:text-4xl bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-transparent">
              Why Choose Ultronics?
            </h2>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {[
              {
                title: "Precision Cleaning",
                description: "Advanced ultrasonic technology for thorough cleaning"
              },
              {
                title: "Custom Solutions:",
                description: "Tailored designs to meet your specific industrial needs"
              },
              {
                title: "Reliable Performance:",
                description: "Durable machines with high-efficiency transducers"
              },
              {
                title: "Comprehensive Support:",
                description: "Full-service assistance from design to maintenance"
              },
              {
                title: "Warranty:",
                description: "All units come with a comprehensive warranty for peace of mind"
              }
            ].map((feature, index) => (
              <div
                key={index}
                className="group block rounded-xl border border-gray-800 p-8 shadow-lg transition-all duration-300 hover:border-blue-500 hover:shadow-blue-500/10"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="size-10 text-pink-500 transition-transform duration-300 group-hover:scale-110"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M12 14l9-5-9-5-9 5 9 5z" />
                  <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
                  />
                </svg>

                <h2 className="mt-4 text-xl font-bold text-black">{feature.title}</h2>
                <p className="mt-1 text-sm text-black">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;